import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import hasPermission from "../../assets/files/hasPermission";
import "./Header.css";


export default function Header() {
  const dropdownRef = useRef(null);

  const [showHeader, setShowHeader] = useState(true);
  const [connected, setConnected] = useState(false);
  const [username, setUsername] = useState("");
  const [groups, setGroups] = useState([]);
  const [isSuperuser, setIsSuperuser] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setUsername(localStorage.getItem("username") || "");
    setConnected(localStorage.getItem("connected") === "true");
    let g = localStorage.getItem("groups");
    g = g ? g.split(","):[];
    setGroups(g);
    setIsSuperuser(localStorage.getItem("is_superuser") === "true");
  }, []);

  const clearCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  };

  const SignOut = (item) => {
      localStorage.clear();

      clearCookie("access_token");
      clearCookie("refresh_token");
      clearCookie("email");
      clearCookie("username");
      clearCookie("groups");
      clearCookie("is_superuser");

      setConnected(false);
      navigate("/home");
      window.location.reload();
      setMenuOpen(false);
  };

  const reloadPage = () => window.location.reload();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [menuOpen]);

  return (
    <div>
      {/* Centered Chevron */}
      <div
        className="chevronHeader"
        onClick={() => setShowHeader(!showHeader)}
      >
        <svg
          viewBox="0 0 24 24"
          width="22"
          height="22"
          style={{ transform: showHeader ? "rotate(180deg)" : "rotate(0deg)", fill: "#6d7176" }}
        >
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path>
        </svg>
      </div>
     

      {/* Header */}
      <div className={showHeader ? "Header header-fadeIn" : "Header header-fadeOut"}>
        <img
          src="/img/et_logo.jpg"
          alt="Logo"
          id="logo"
          onClick={reloadPage}
          style={{ width: "200px", height: "auto" }}
        />

        <Link to="/Home">
          <button className="nav-btn">HOME</button>
        </Link>

        {hasPermission("view_pbsElements") && (
          <Link to="/Elements/1">
            <button className="nav-btn">PBS ELEMENTS (V2 October 2025)</button>
          </Link>
        )}

        {hasPermission("view_parameters") && (
          <Link to="/Parameters/1">
            <button className="nav-btn">PARAMETERS</button>
          </Link>
        )}

        <Link to="/Parameters_File_Generator">
          <button className="nav-btn">FILE GENERATOR</button>
        </Link>

        <Link to="/Risks_File_Generator">
          <button className="nav-btn">RISKS</button>
        </Link>
        
        {hasPermission("broadcast") && (
          <Link to="/users_broadcast">
            <button className="nav-btn">BROADCAST</button>
          </Link>
        )}

        <div style={{ flex: 1 }}></div> {/* Spacer */}


        {/* Profile / Sign In */}
        {connected ? (
          <div className="profile-container" ref={dropdownRef}>
            <button className="default-btn primary" onClick={() => setMenuOpen(!menuOpen)}>
              PROFILE
            </button>

            {menuOpen && (
              <div className="dropdown-menu">
                {hasPermission("update_profile") && (
                  <Link to="/profile" style={{textDecoration:"none"}}>
                    <div className="dropdown-item">My Account</div>
                  </Link>
                )}

              <Link to="/users/1" style={{ textDecoration: "none" }}>
                <div className="dropdown-item">
                  {hasPermission("view_profiles")
                    ? "Accounts Administration"
                    : "Accounts"}
                </div>
              </Link>

              <div className="dropdown-item" onClick={SignOut}>
                Sign Out 🔒
              </div>
              </div>
            )}
          </div>
        ) : (
          <Link to="/ConnectionPopUp">
            <button className="default-btn primary">SIGN IN</button>
          </Link>
        )}

      </div>
    </div>
  );
}
